import React,{useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import { toast } from 'react-toastify';

import ValidationMessage from '../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';
const DevProfileUpdateForm = (props) => {
    const {profileData} = props;
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    // ------ defile all state here ------- //
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [profileUpdateFormData, setProfileUpdateFormData] = useState({
        full_name : "",
        email: "",
        old_password : "" ,
        new_password: "",
        confirm_password: ""
    });
    const [profileUpdateFormError, setProfileUpdateFormError] = useState({});
    const [isButtonLoader, setIsButtonLoader] = useState(false)

    const validateField = (name, value) => {
        let error = "";
        if (name === "full_name") {
            if (!value) {
                error = "Username is required";
            } 
        }
        if(
            profileUpdateFormData.old_password !== '' || 
            profileUpdateFormData.new_password !== '' || 
            profileUpdateFormData.confirm_password !== ''
        ){
            if(name === 'old_password'){
                if (!value) {
                    error = "Old password is required";
                }
            }
            if(name === 'new_password'){
                if (!value) {
                    error = "New password is required";
                }
                else if(profileUpdateFormData.confirm_password !== ''){
                    if(value !== profileUpdateFormData.confirm_password){
                        setProfileUpdateFormError((prevErrors) => ({
                            ...prevErrors,
                            'confirm_password': `New password and confirmation password doesn't match.`,
                        }));
                    }
                    else{
                        setProfileUpdateFormError((prevErrors) => ({
                            ...prevErrors,
                            'confirm_password': ``,
                        }));
                    }
                }
            }
            if(name === 'confirm_password'){
                if (!value) {
                    error = "Confirm password is required";
                }
                else if(value !== profileUpdateFormData.new_password){
                    error = "New password and confirmation password doesn't match.";
                }
            }
        }
        return error;
    };

    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setProfileUpdateFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setProfileUpdateFormData((prevData) => ({
            ...prevData,
            [name]: value.trim(),
        }));
    }

    useEffect(() => {
        if(Object.keys(profileData).length > 0){
            setProfileUpdateFormData({
                full_name: profileData.user_full_name,
                email: profileData.user_email,
                old_password : "" ,
                new_password: "",
                confirm_password: ""
            })
        }
    },[profileData])

    const updateHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in profileUpdateFormData) {
            newErrors[key] = validateField(key, profileUpdateFormData[key]);
        }
        setProfileUpdateFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setIsButtonLoader(true)
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'D') {
                apiToken = localStorage.getItem('developertoken')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            await axios.post(`${api_base_url}developer/update-developer-info`, profileUpdateFormData, api_headers)
            .then(async (res) => {
                setIsButtonLoader(false)
                if(res.data.status === 'success') {
                    toast.success(res.data.message);
                    props.setIsUpdate(false)
                    props.profileFormData(profileUpdateFormData)
                } else if(res.data.status === 'error') {
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                setIsButtonLoader(false)
                console.error(error);
            })
        }
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                            Full Name
                        </label>
                        <div className="col-lg-8 fv-row fv-plugins-icon-container">
                            <input
                                type="text" 
                                name="full_name" 
                                className="form-control form-control-lg form-control-solid" 
                                placeholder="Enter your name"
                                value={profileUpdateFormData.full_name}
                                onChange={inputChangeHandler}
                            />
                            {profileUpdateFormError.full_name && 
                                <ValidationMessage 
                                    className='text-danger' 
                                    message ={profileUpdateFormError.full_name}
                                />
                            }
                        </div>
                    </div>
                    <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                            Email
                        </label>
                        <div className="col-lg-8 fv-row fv-plugins-icon-container">
                            <input 
                                type="text" 
                                name="email" 
                                className="form-control form-control-lg form-control-solid" 
                                placeholder="Enter your email" 
                                value={profileUpdateFormData.email}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-6">
                        <div className='col-md-4'>
                            <label className="col-form-label required fw-semibold fs-6 pb-0">
                                Password
                            </label>
                            <span className="text-gray-400 d-block">
                                If you want to change your password, please fill in the form.
                            </span>
                        </div>
                        <div className="col-lg-8">
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className="input-group input-group-solid">
                                        <input
                                            type="text" 
                                            className={`form-control ${!showOld && 'inp-secure'}`} 
                                            placeholder="Old password"
                                            name="old_password"
                                            onChange={inputChangeHandler}
                                            value={profileUpdateFormData.old_password}
                                        />
                                        <span className="input-group-text">
                                            <FontAwesomeIcon
                                                icon={showOld ? faEyeSlash : faEye}
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={()=> setShowOld(!showOld)}
                                            />
                                        </span>
                                    </div>
                                    {profileUpdateFormError.old_password && 
                                        <ValidationMessage 
                                            className='text-danger' 
                                            message ={profileUpdateFormError.old_password}
                                        />
                                    }
                                </div>
                                <div className='col-md-4'>
                                    <div className="input-group input-group-solid">
                                        <input
                                            type="text" 
                                            className={`form-control ${!showNew && 'inp-secure'}`}
                                            placeholder="New password"
                                            name="new_password"
                                            onChange={inputChangeHandler}
                                            value={profileUpdateFormData.new_password}
                                        />
                                        <span className="input-group-text">
                                            <FontAwesomeIcon
                                                icon={showNew ? faEyeSlash : faEye}
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={()=> setShowNew(!showNew)}
                                            />
                                        </span>
                                    </div>
                                    {profileUpdateFormError.new_password && 
                                        <ValidationMessage 
                                            className='text-danger' 
                                            message ={profileUpdateFormError.new_password}
                                        />
                                    }
                                </div>
                                <div className='col-md-4'>
                                    <div className="input-group input-group-solid">
                                        <input 
                                            type="text"
                                            className={`form-control ${!showConfirm && 'inp-secure'}`}
                                            placeholder="Confirm password"
                                            name="confirm_password"
                                            onChange={inputChangeHandler}
                                            value={profileUpdateFormData.confirm_password}
                                        />
                                        <span className="input-group-text">
                                            <FontAwesomeIcon
                                                icon={showConfirm ? faEyeSlash : faEye}
                                                className='fs-4 cursor-pointer text-gray-500'
                                                onClick={()=> setShowConfirm(!showConfirm)}
                                            />
                                        </span>
                                    </div>
                                    {profileUpdateFormError.confirm_password && 
                                        <ValidationMessage 
                                            className='text-danger' 
                                            message ={profileUpdateFormError.confirm_password}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12 text-end">
                            <div 
                                className="btn btn-danger me-4" 
                                onClick={() => props.setIsUpdate(false)}
                            >
                                Cancel
                            </div>
                            <div
                                className={`btn btn-primary ${isButtonLoader && 'disabled'}`}
                                onClick={updateHandler}

                            >
                                {
				                    isButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save'
			                    }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DevProfileUpdateForm